import React from 'react';
import { Modal, Form } from 'antd';
import FileInput from '../../components/common/FileInput';
const FormItem = Form.Item;

const UploadResumeForm = Form.create()(
  (props) => {
    const { visible, onCancel, onCreate, form} = props;
    const { getFieldDecorator } = form;
    const config = {
      sourceFile: {
        rules: [{
          type: 'object',
          required: true,
          message: '请上传人才简历'
        }],
        initialValue: ''
      },
    }
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 }
    }
    return (
      <Modal
        visible={visible}
        title="简历上传"
        okText="保存"
        onCancel={onCancel}
        onOk={onCreate}
        maskClosable={false}
      >
        <Form layout="vertical">
          <FormItem label="简历文件" {...formItemLayout}>
            {getFieldDecorator('sourceFile', config.sourceFile)(
              <FileInput />
            )}
          </FormItem>
        </Form>
      </Modal>
    )
  }
)

export default UploadResumeForm;


// WEBPACK FOOTER //
// ./src/components/telant/uploadResume.js